export const gitCommit = '4d3743f7'
